<div class="service-order-content">
  <!-- Información de la subtarea en dos columnas -->
  <div class="service-order-grid">
    <!-- Columna izquierda -->
    <div class="detail-column">
      <!-- Nombre de la subtarea -->
      <div class="detail-row">
        <span class="detail-label" style="text-transform: none;">Nombre de la subtarea:</span>
        <span *ngIf="!isFieldEditing('subtaskName')" class="detail-value" [class.empty]="!serviceOrderName"
          (click)="onFieldClick('subtaskName', $event)" style="cursor: pointer;">{{ getDisplayValue(serviceOrderName,
          '-') }}</span>
        <input *ngIf="isFieldEditing('subtaskName')" type="text" nzSize="large" nz-input
          [(ngModel)]="tempFieldValues['subtaskName']" (blur)="onFieldBlur('subtaskName', $event)"
          [attr.data-field]="'subtaskName'" placeholder="Introduce nombre..." style="width: 200px;"
          [class.has-value]="tempFieldValues['subtaskName']" [class.empty-value]="!tempFieldValues['subtaskName']">
      </div>

      <!-- Asignada a -->
      <div class="detail-row">
        <span class="detail-label" style="text-transform: none;">Asignada a:</span>
        <span *ngIf="!isFieldEditing('assignedUserId')" class="detail-value"
          [class.empty]="!assignedUser || assignedUser === 'Sin asignar'"
          (click)="onFieldClick('assignedUserId', $event)" style="cursor: pointer;">{{ getDisplayValue(assignedUser,
          '-') }}</span>
        <nz-select *ngIf="isFieldEditing('assignedUserId')" nzSize="large" [id]="partnersSelectId"
          [ngModel]="tempFieldValues['assignedUserId']" (ngModelChange)="onSelectChange('assignedUserId', $event)"
          [attr.data-field]="'assignedUserId'" nzPlaceHolder="Seleccione usuario" nzShowSearch nzAllowClear
          style="width: 200px;" [class.has-value]="tempFieldValues['assignedUserId']"
          [class.empty-value]="!tempFieldValues['assignedUserId']">
          <nz-option *ngFor="let partner of availablePartners; trackBy: trackByPartner" [nzValue]="partner.id"
            [nzLabel]="getUserDisplayName(partner)">
          </nz-option>
        </nz-select>
      </div>

      <!-- Fecha inicio y fin -->
      <div class="detail-row">
        <span class="detail-label" style="text-transform: none;">Fecha inicio y de fin:</span>
        <div class="date-range-container" style="display: flex; align-items: center;">
          <!-- Fecha inicio -->
          <div class="date-field-container">
            <span *ngIf="!isFieldEditing('startDate')" class="detail-value date-with-icon" [class.empty]="!startDate"
              (click)="onFieldClick('startDate', $event)" style="cursor: pointer;">
              <app-st-icon name="calendar_today" style="margin-right: 4px;"></app-st-icon>
              {{ formatDateWithIcon(startDate) }}
            </span>
            <nz-date-picker *ngIf="isFieldEditing('startDate')" nzSize="large" [ngModel]="tempFieldValues['startDate']"
              (ngModelChange)="onDateChange('startDate', $event)" [attr.data-field]="'startDate'" nzPlaceHolder="Inicio"
              style="width: 120px;" [class.has-value]="tempFieldValues['startDate']"
              [class.empty-value]="!tempFieldValues['startDate']"></nz-date-picker>
          </div>

          <!-- Separador -->
          <span class="date-separator">-</span>

          <!-- Fecha fin -->
          <div class="date-field-container">
            <span *ngIf="!isFieldEditing('endDate')" class="detail-value date-with-icon" [class.empty]="!endDate"
              (click)="onFieldClick('endDate', $event)" style="cursor: pointer;">
              <app-st-icon name="calendar_today" style="margin-right: 4px;"></app-st-icon>
              {{ formatDateWithIcon(endDate) }}
            </span>
            <nz-date-picker *ngIf="isFieldEditing('endDate')" nzSize="large" [ngModel]="tempFieldValues['endDate']"
              (ngModelChange)="onDateChange('endDate', $event)" [attr.data-field]="'endDate'" nzPlaceHolder="Fin"
              style="width: 120px;" [class.has-value]="tempFieldValues['endDate']"
              [class.empty-value]="!tempFieldValues['endDate']"></nz-date-picker>
          </div>
        </div>
      </div>

    </div>

    <!-- Columna derecha -->
    <div class="detail-column">
      <!-- Centro de costo -->
      <div class="detail-row">
        <span class="detail-label" style="text-transform: none;">Centro de costo:</span>
        <span *ngIf="!isFieldEditing('costCenterId')" class="detail-value" [class.empty]="!costCenterDisplay"
          (click)="onFieldClick('costCenterId', $event)" style="cursor: pointer;">{{ getDisplayValue(costCenterDisplay,
          '-') }}</span>
        <nz-select *ngIf="isFieldEditing('costCenterId')" nzSize="large" [ngModel]="tempFieldValues['costCenterId']"
          (ngModelChange)="onSelectChange('costCenterId', $event)" [attr.data-field]="'costCenterId'"
          nzPlaceHolder="Seleccione centro de costo" nzShowSearch nzAllowClear style="width: 200px;"
          [class.has-value]="tempFieldValues['costCenterId']" [class.empty-value]="!tempFieldValues['costCenterId']">
          <nz-option *ngFor="let costCenter of costCenters" [nzValue]="costCenter.id" [nzLabel]="costCenter.name">
          </nz-option>
        </nz-select>
      </div>

      <!-- Prioridad -->
      <div class="detail-row">
        <span class="detail-label" style="text-transform: none;">Prioridad:</span>
        <span *ngIf="!isFieldEditing('priority')" class="detail-value priority-stars" [class.empty]="!priorityName"
          (click)="onFieldClick('priority', $event)" style="cursor: pointer;">
          <span *ngFor="let star of getStarsArray(serviceOrder?.priority); let i = index" class="star"
            [class.filled]="i < getFilledStars(serviceOrder?.priority)">★</span>
        </span>
        <nz-select *ngIf="isFieldEditing('priority')" nzSize="large" [ngModel]="tempFieldValues['priority']"
          (ngModelChange)="onSelectChange('priority', $event)" [attr.data-field]="'priority'"
          nzPlaceHolder="Seleccione prioridad" nzShowSearch nzAllowClear style="width: 200px;"
          [class.has-value]="tempFieldValues['priority']" [class.empty-value]="!tempFieldValues['priority']">
          <nz-option nzValue="Low" nzLabel="Baja"></nz-option>
          <nz-option nzValue="Medium" nzLabel="Media"></nz-option>
          <nz-option nzValue="High" nzLabel="Alta"></nz-option>
          <nz-option nzValue="VeryHigh" nzLabel="Muy Alta"></nz-option>
        </nz-select>
      </div>

      <!-- Tarea macro -->
      <div class="detail-row">
        <span class="detail-label" style="text-transform: none;">Tarea macro:</span>
        <span *ngIf="!isFieldEditing('macroTask')" class="detail-value" [class.empty]="!macroTask"
          (click)="onFieldClick('macroTask', $event)" style="cursor: pointer;">{{ getDisplayValue(macroTask, '-')
          }}</span>
        <input *ngIf="isFieldEditing('macroTask')" type="text" nzSize="large" nz-input
          [(ngModel)]="tempFieldValues['macroTask']" (blur)="onFieldBlur('macroTask', $event)"
          [attr.data-field]="'macroTask'" placeholder="Introduce tarea macro..." style="width: 200px;"
          [class.has-value]="tempFieldValues['macroTask']" [class.empty-value]="!tempFieldValues['macroTask']">
      </div>

      <!-- Cierre previsto -->
      <div class="detail-row">
        <span class="detail-label" style="text-transform: none;">Cierre previsto:</span>
        <span *ngIf="!isFieldEditing('expectedClosure')" class="detail-value" [class.empty]="!expectedClosingDate"
          (click)="onFieldClick('expectedClosure', $event)" style="cursor: pointer;">{{
          getDisplayValue(expectedClosingDate, '-') }}</span>
        <nz-date-picker *ngIf="isFieldEditing('expectedClosure')" nzSize="large"
          [ngModel]="tempFieldValues['expectedClosure']" (ngModelChange)="onDateChange('expectedClosure', $event)"
          [attr.data-field]="'expectedClosure'" nzPlaceHolder="Seleccione fecha" style="width: 200px;"
          [class.has-value]="tempFieldValues['expectedClosure']"
          [class.empty-value]="!tempFieldValues['expectedClosure']"></nz-date-picker>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <nz-tabset *ngIf="afterViewInit" [(nzSelectedIndex)]="activeTabIndex">
    <nz-tab [nzTitle]="descripcionTemplate">
      <ng-template #descripcionTemplate>
        <app-st-icon style="margin-right: 5px" [name]="'menu_book'"></app-st-icon>
        Descripción
      </ng-template>
      <div class="tab-content">
        <p *ngIf="!isFieldEditing('description')" class="text-label-14 text-dark"
          style="white-space: pre-wrap; cursor: pointer;" (click)="onFieldClick('description', $event)">{{
          serviceOrder?.description || '-' }}</p>
        <textarea *ngIf="isFieldEditing('description')" nzSize="large" nz-input [ngModel]="serviceOrder?.
        description || ''" (blur)="onFieldBlur('description', $event)" [attr.data-field]="'description'"
          placeholder="Introduce descripción..." rows="10" style="width: 100%; min-height: 200px; white-space:
          pre-wrap;">
                </textarea>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="documentosTemplate">
      <ng-template #documentosTemplate>
        <app-st-icon style="margin-right: 5px" [name]="'description'"></app-st-icon>
        Documentos
      </ng-template>
      <div class="tab-content">
        <app-doc-section [entityType]="'ServiceOrder'" [entityId]="serviceOrderId" [documents]="documents || []">
        </app-doc-section>
      </div>
    </nz-tab>

  </nz-tabset>
</div>